import { useDispatch } from "react-redux";

import { Button } from "@/components/Shared/Button";
import { setConnectionStatus } from "@/redux/features/InternetConnect/InternetConnectSlice";

export const NoInternetScreen = () => {
  const dispatch = useDispatch();

  const checkConnection = () => {
    dispatch(setConnectionStatus(navigator.onLine));
  }

  return (
    <div className="vertical-center min-h-screen px-4 text-center bg-gray-100">
      <h1 className="mb-4 text-3xl font-bold text-neutral font-outfit">It looks like you have no internet connection</h1>
      <p className="mb-6 text-neutral-dark1">Please check your network settings.</p>
      <Button
        variant='contained'
        color='secondary.lightMintGreen'
        radius='4px'
        width='8rem'
        textColor='black'
        type='submit'
        className={
          '!uppercase !border-[1px] !border-solid !border-black !font-baskervville max-md:!hidden'
        }
        onClick={checkConnection}
      >
        Retry
      </Button>
    </div>
  )
};